<template>
  <UkiModal :modalId="modalId" :title="title" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="rgg-platform">Платформа</label>
      <uki-select-control id="rgg-platform"
                          :model-value="rggPlatformId"
                          :options="rggPlatforms"
                          empty-title="Не выбрана"
                          required="true"
                          text-field="shortName"
                          value-field="id"
                          @update:model-value="value => $emit('update:rggPlatformId', value)"
      />
    </div>
    <div class="form-group">
      <label for="game-rate">Кол-во</label>
      <input id="game-rate" :value="gameCount" type="number" @input="$emit('update:gameCount', $event.target.value)" required />
    </div>
    <div class="form-group">
      <label for="comment">Комментарий</label>
      <textarea id="comment" :value="comment" rows="4" @input="$emit('update:comment', $event.target.value)">
      </textarea>
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";
import UkiSelectControl from "@/components/UkiSelectControl";

export default {
  name: "PlusGameChangedModal",
  components: {UkiModal, UkiSelectControl},
  props: ["modalId", "operationType", "rggPlatforms",
    "rggPlatformId", "gameCount", "comment"],
  emits: ["ok", "close", "update:rggPlatformId", "update:gameCount", "update:comment"],
  computed: {
    title: function () {
      switch (this.operationType) {
        case 'PlusGame':
          return "Плюс игра"
        case 'MinusGame':
          return "Минус игра"
        case 'PlusExtraGame':
          return "Плюс экстра игра"
        case 'MinusExtraGame':
          return "Минус экстра игра"
        default:
          return ""
      }
    }
  }
}
</script>

<style scoped>

</style>